import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { Button, Col, Form, Row } from "react-bootstrap";
import { allSharedComponents } from "../../../../../shared";
import {
  fieldLengthConstants,
  globalConstants,
  modeConstants,
  translationConstants,
  Directions,
  Regex,
  sportConstants,
} from "../../../../../constants";
import { boatTypeActions } from "../../../../../redux/actions";
import { genderAllowed } from "../utilities";
import { getSportDataForDropdown } from "../../../../../system";

const AddBoatClass = (props) => {
  const { Mandatory_Character } = globalConstants;
  const { InputFieldWrapper } = allSharedComponents;

  const { t } = useTranslation();
  const dispatch = useDispatch();

  const [boatTypeOptions, setBoatTypeOptions] = useState([]);
  const [boatTypeSelection, setBoatTypeSelection] = useState(false);

  const {
    setValue,
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const boatClassesDataById = useSelector(
    (state) => state.BoatTypeReducer.boatClassesDataById
  );

  const onSubmit = (data) => {
    let boatClassesData = data;

    if (props?.mode === modeConstants.ADD_MODE) {
      dispatch(
        boatTypeActions.addBoatClass(boatClassesData, () => {
          props?.setShowModal(false);
        })
      );
    } else if (props.mode === modeConstants.EDIT_MODE) {
      boatClassesData = { ...boatClassesData, id: boatClassesDataById?.id };
      dispatch(
        boatTypeActions.updateBoatClass(boatClassesData, () => {
          props?.setShowModal(false);
        })
      );
    }
  };

  useEffect(() => {
    if (props?.mode !== modeConstants.ADD_MODE) {
      setValue("sportId", boatClassesDataById?.sportId);
      if (boatClassesDataById?.sportId) {
        setBoatTypeOptions(
          getSportDataForDropdown(t, boatClassesDataById?.sportId)
        );
        setBoatTypeSelection(true);
      }
      setValue("name", boatClassesDataById?.name);
      setValue("arabicName", boatClassesDataById?.arabicName);
      const gendersStringArray = boatClassesDataById?.genders?.map((x) =>
        x.toString()
      );
      setValue("genders", gendersStringArray);
      setValue("description", boatClassesDataById?.description);
      setValue("arabicDescription", boatClassesDataById?.arabicDescription);
    }
    //eslint-disable-next-line
  }, [dispatch, boatClassesDataById]);

  useEffect(() => {
    if (boatTypeOptions.length > 0 && boatTypeSelection) {
      setValue("boatTypeId", boatClassesDataById?.boatTypeId);
      setBoatTypeSelection(false);
    }
    //eslint-disable-next-line
  }, [boatTypeOptions, boatClassesDataById]);

  return (
    <section>
      <div className="ViewHeader">
        <p className="viewUserPara">
          {props?.mode === modeConstants.EDIT_MODE
            ? t(translationConstants.EDIT_BOAT_CLASS)
            : props?.mode === modeConstants.ADD_MODE
            ? t(translationConstants.ADD_BOAT_CLASS)
            : t(translationConstants.VIEW_BOAT_CLASS)}
        </p>
      </div>
      <p className="horizentalLine" />
      <div className="m-t-24">
        <Form
          noValidate
          className="ViewUserContent ViewUserContentForm"
          onSubmit={handleSubmit(onSubmit)}
        >
          <Row>
            <InputFieldWrapper
              label={
                `${t(translationConstants.SPORT_TYPE)}:` + Mandatory_Character
              }
            >
              <Form.Select
                id="sportId"
                {...register("sportId", {
                  required: t(translationConstants.SPORT_TYPE_IS_REQUIRED),
                })}
                onChange={(event) => {
                  setBoatTypeOptions(
                    getSportDataForDropdown(t, event.target.value)
                  );
                }}
                disabled={props.mode === modeConstants.VIEW_MODE}
              >
                <option value="">
                  {t(translationConstants.SELECT_SPORT_TYPE)}
                </option>
                {Object.entries(sportConstants).map(([sport, value]) => (
                  <option key={value} value={value}>
                    {t(translationConstants[sport])}
                  </option>
                ))}
              </Form.Select>
              {errors?.sportId && (
                <p className="errorText">{errors?.sportId.message}</p>
              )}
            </InputFieldWrapper>

            <InputFieldWrapper
              label={
                `${t(translationConstants.BOAT_TYPE)}:` + Mandatory_Character
              }
            >
              <Form.Select
                id="boatTypeId"
                disabled={props.mode === modeConstants.VIEW_MODE}
                {...register("boatTypeId", {
                  required: t(translationConstants.BOAT_TYPE_REQUIRED),
                })}
              >
                <option value="">
                  {t(translationConstants.SELECT_BOAT_TYPE)}
                </option>
                {boatTypeOptions.map((object) => (
                  <option key={object.value} value={object.value}>
                    {t(translationConstants[object.label])}
                  </option>
                ))}
              </Form.Select>
              {errors?.boatTypeId && (
                <p className="errorText">{errors?.boatTypeId.message}</p>
              )}
            </InputFieldWrapper>

            <InputFieldWrapper
              label={
                `${t(translationConstants.BOAT_CLASS_NAME)}:` +
                Mandatory_Character
              }
            >
              <Form.Control
                type="text"
                id="name"
                maxLength={fieldLengthConstants.TEXT_FIELD_LENGTH}
                disabled={props.mode === modeConstants.VIEW_MODE}
                placeholder={t(translationConstants.ENTER_BOAT_CLASS_NAME)}
                {...register("name", {
                  required: t(translationConstants.BOAT_CLASS_NAME_REQUIRED),
                  maxLength: {
                    value: fieldLengthConstants.TEXT_FIELD_LENGTH,
                    message: t(translationConstants.BOAT_CLASS_NAME_TOO_LONG),
                  },
                  pattern: {
                    value: Regex.titleRegex,
                    message: t(translationConstants.INVALID_BOAT_NAME),
                  },
                })}
              />
              {errors?.name && (
                <p className="errorText">{errors?.name.message}</p>
              )}
            </InputFieldWrapper>

            <InputFieldWrapper
              label={
                <>
                  {t(translationConstants.BOAT_CLASS_NAME)}: (
                  {t(translationConstants.ARABIC)})
                </>
              }
            >
              <Form.Control
                id="arabicName"
                dir={Directions.rtl}
                type="text"
                maxLength={fieldLengthConstants.TEXT_FIELD_LENGTH}
                disabled={props.mode === modeConstants.VIEW_MODE}
                placeholder="أدخل اسم فئة القارب"
                {...register("arabicName", {
                  maxLength: {
                    value: fieldLengthConstants.TEXT_FIELD_LENGTH,
                    message: t(
                      translationConstants.BOAT_CLASS_ARABIC_NAME_TOO_LONG
                    ),
                  },
                })}
              />
              {errors?.arabicName && (
                <p className="errorText">{errors?.arabicName.message}</p>
              )}
            </InputFieldWrapper>

            <InputFieldWrapper
              label={`${t(translationConstants.gender)}:` + Mandatory_Character}
            >
              <div className="d-flex ga-2 flex-wrap">
                {genderAllowed(t).map((option, index) => (
                  <Form.Group
                    key={index}
                    className="px-2"
                    controlId={option.value}
                  >
                    <Form.Check
                      className="offer"
                      type="checkbox"
                      value={option.value}
                      label={<p>{option.label}</p>}
                      disabled={props.mode === modeConstants.VIEW_MODE}
                      {...register(`genders`, {
                        validate: {
                          atLeastOne: (value) =>
                            value.length > 0 ||
                            t(
                              translationConstants.BOAT_CLASS_REQUIRED_ATLEAST_ONE_GENDER
                            ),
                        },
                      })}
                    />
                  </Form.Group>
                ))}
              </div>
              {errors?.genders && (
                <p className="errorText">{errors?.genders?.message}</p>
              )}
            </InputFieldWrapper>

            <InputFieldWrapper
              md={12}
              label={
                <>
                  {t(translationConstants.CLASS_DESCRIPTION)}:
                  {Mandatory_Character}
                </>
              }
            >
              <Form.Control
                type="text"
                id="description"
                as="textarea"
                disabled={props.mode === modeConstants.VIEW_MODE}
                rows={2}
                placeholder={t(translationConstants.ENTER_CLASS_DESCRIPTION)}
                {...register("description", {
                  required: t(translationConstants.CLASS_DESCRIPTION_REQUIRED),
                })}
              />
              {errors?.description && (
                <p className="errorText">{errors?.description.message}</p>
              )}
            </InputFieldWrapper>

            <InputFieldWrapper
              md={12}
              label={
                <>
                  {t(translationConstants.CLASS_DESCRIPTION)}: (
                  {t(translationConstants.ARABIC)})
                </>
              }
            >
              <Form.Control
                dir={Directions.rtl}
                type="text"
                id="arabicDescription"
                as="textarea"
                disabled={props.mode === modeConstants.VIEW_MODE}
                rows={2}
                placeholder={"أدخل الوصف العربي للصف"}
                {...register("arabicDescription", {})}
              />
              {errors?.arabicDescription && (
                <p className="errorText">
                  {errors?.arabicDescription?.message}
                </p>
              )}
            </InputFieldWrapper>

            {props?.mode !== modeConstants.VIEW_MODE && (
              <Col className="mx-1 d-flex justify-content-center">
                <Button className="btn-submit mb-2" type="submit">
                  {props?.mode === modeConstants.ADD_MODE
                    ? t(translationConstants.submit)
                    : t(translationConstants.Update)}
                </Button>
              </Col>
            )}
          </Row>
        </Form>
      </div>
    </section>
  );
};

export default AddBoatClass;
